import React, { FC } from 'react';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { StrategySelector } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/StrategySelector';
import { AmountsInput } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/AmountsInput';
import { useDerivedSteerInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedSteerMintInfo';
import { CreatePositionWithKpNft } from '../CreatePositionWithKpNft/CreatePositionWithKpNft';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const AddLiquidityBySteer: FC<Props> = ({ mintInfo }) => {
  const { currencyA } = useLiquidityWizardState();
  const { poolAddress } = mintInfo;

  const mintInfoWithProvider = useDerivedSteerInfo(poolAddress, currencyA);

  return (
    <>
      <StrategySelector mintInfo={mintInfoWithProvider} />
      <AmountsInput mintInfo={mintInfoWithProvider} />
      <CreatePositionWithKpNft mintInfo={mintInfoWithProvider} />
    </>
  );
};
